$(document).ready(function() {
    var tech_company = $("form.tech_days_form input[name=tech_company]").val();

    $('form.tech_days_form .dform input[type=hidden]').val(tech_company);
});